



















import { IRepairEstimate } from "@/models/repair-estimate.entity";
import Vue from "vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import SideCard from "../utility/SideCard.vue";
import RepairEstimateDetail from "./RepairEstimateDetail.vue";

@Component({
  components: { SideCard, RepairEstimateDetail, LatestEntriesCardEmpty }
})
export default class RepairEstimateSideCard extends mixins(Vue) {
  @Prop()
  value!: IRepairEstimate;

  loading = false;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  close() {
    this.$emit("close");
  }

  emitDeleteEstimate() {
    this.$emit("delete", this.value);
  }
}
